'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const theme_LegacyColorMap = require('../../../theme/LegacyColorMap.cjs.js');
const components_display_Avatar_Avatar = require('../../display/Avatar/Avatar.cjs.js');
require('react');
require('clsx');
const components_marketing_TestimonialSolo_TestimonialMapping = require('./TestimonialMapping.cjs.js');

const root = "_root_149qz_1";
const content = "_content_149qz_6";
const avatarContainer = "_avatar-container_149qz_20";
const quote = "_quote_149qz_25";
const author = "_author_149qz_43";
const company = "_company_149qz_61";
const styles = {
	root: root,
	content: content,
	avatarContainer: avatarContainer,
	quote: quote,
	author: author,
	company: company
};

const TestimonialSolo = ({ backgroundColor, avatarUrl, hasAuthorAvatar = true, quote, author, company }) => {
  return jsxRuntime.jsx("div", { className: styles.root, style: {
    "--_zds-testimonialsolo-background-color": theme_Colors.Colors[theme_LegacyColorMap.LegacyColorMap[components_marketing_TestimonialSolo_TestimonialMapping.remapDeprecatedColors(backgroundColor || "neutral100")]]
  }, "data-zds": true, children: jsxRuntime.jsxs("div", { className: styles.content, "data-zds": true, children: [hasAuthorAvatar && jsxRuntime.jsx("div", { className: styles.avatarContainer, "data-zds": true, children: jsxRuntime.jsx(components_display_Avatar_Avatar.Avatar, { "data-testId": "Avatar", name: author, url: avatarUrl, size: "medium" }) }), jsxRuntime.jsx("div", { className: styles.quote, "data-zds": true, children: quote }), jsxRuntime.jsx("p", { className: styles.author, "data-zds": true, children: author }), jsxRuntime.jsx("p", { className: styles.company, "data-zds": true, children: company })] }) });
};

exports.TestimonialSolo = TestimonialSolo;
//# sourceMappingURL=TestimonialSolo.cjs.js.map
